import { Folder } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { MediaFolderDocument } from '../../services/admin.mediaFolders.service'

interface MediaFolderCardProps {
  folder: MediaFolderDocument
  onClick: () => void
}

export function MediaFolderCard({ folder, onClick }: MediaFolderCardProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'group relative flex flex-col overflow-hidden rounded-lg border bg-card text-left transition-colors hover:border-primary'
      )}
    >
      {/* Icon area */}
      <div className="relative aspect-square w-full overflow-hidden bg-muted flex items-center justify-center transition-colors group-hover:bg-muted/70">
        <Folder className="h-10 w-10 text-muted-foreground/60 transition-colors group-hover:text-primary/70" />
      </div>

      {/* Name */}
      <div className="px-2 py-1.5">
        <p className="truncate text-xs font-medium" title={folder.name}>
          {folder.name}
        </p>
        <p className="text-[10px] text-muted-foreground">Folder</p>
      </div>
    </button>
  )
}
